import React, { useState } from 'react';

export default function IntroScreen({ onStart }) {
  const [fading, setFading] = useState(false);

  const handleStart = () => {
    setFading(true);
    setTimeout(onStart, 800);
  };

  return (
    <div className={`intro-screen ${fading ? 'intro-fade' : ''}`}>
      <div className="intro-content">
        <div className="intro-compass">🧭</div>
        <h1 className="intro-title">Our  &lt;3 Story</h1>
        <p className="intro-subtitle">An Adventure of Two</p>
        <div className="intro-divider">~ ~ ~</div>
        <p className="intro-text">
          Happy Anniversary my love! <br />Forever and ever grateful for you!!!!
          <br /><br />
          A gift for you, to celebrate every incredible memory we've made together. I turned our
          favorite places into a treasure map.
          <br /><br />
          Solve the clues to unlock our story so far... <br />the best chapters are still unwritten! ;)
        </p>
        <button className="intro-btn" onClick={handleStart}>
          Bring It On
        </button>
      </div>

      {/* Decorative doodles */}
      <div className="intro-doodle intro-doodle-palm">🌴</div>
      <div className="intro-doodle intro-doodle-wave">🌊</div>
      <div className="intro-doodle intro-doodle-sun">☀️</div>
      <div className="intro-doodle intro-doodle-heart">💛</div>
    </div>
  );
}
